<template>
  <div id="login" class="text-center">
      <section class="form">
        <form class="form-signin" @submit.prevent="login">
          <h1>Please Sign In</h1>
          <p>(NOTE: For this demo, the Admin account is username: admin, password: password)</p>
          <div class="alert alert-danger" role="alert" v-if="invalidCredentials">
            <i class="fa fa-triangle-exclamation"></i> Invalid username and
            password!
          </div>
          <div
            class="alert alert-success"
            role="alert"
            v-if="this.$route.query.registration"
          >
            Thank you for registering, please sign in.
          </div>
          <div id="login">
            <label for="username" class="sr-only">Username</label>
            <input
              type="text"
              id="username"
              class="form-control"
              placeholder="Username"
              v-model="user.username"
              required
              autofocus
            />
          </div>
          <div id="password">
            <label for="password" class="sr-only">Password</label>
            <input
              type="password"
              id="password"
              class="form-control"
              placeholder="Password"
              v-model="user.password"
              required
            />
          </div>
            <router-link :to="{ name: 'register-view' }">Need an account?</router-link>
            <button type="submit" class="button">Sign in</button>
        </form>
      </section>
    </div>
</template>

<script>
  
export default {
  components: {},
  data() {
    return {
      user: {
        username: "",
        password: "",
      },
      invalidCredentials: false,
    };
  },
  methods: {
    login() {
      let userStrg = this.user.username.toLocaleLowerCase();
      let doesUserExist = this.$store.getters.findUser(userStrg);
      if(doesUserExist !== 0) {
        this.$store.commit("SET_USERNAME",this.user.username);
      if(doesUserExist.role === "admin") {
          this.$store.commit("SET_ADMIN");
          this.$router.push("/");
      } else if(doesUserExist.role === "brewer") {
          this.$store.commit("SET_BREWER");
          this.$router.push("/");
      } else {
          this.$router.push("/");
      }
      } else {
        this.invalidCredentials = true;
      }
    },
  },
};
</script>